import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../hooks/usePermissions';
import { useAuthStore } from '../../store/auth.store';
import { getFirstAccessibleRoute } from '../../utils/route-utils';

interface RouteGuardProps {
  moduleName: string;
  children: React.ReactNode;
}

export const RouteGuard: React.FC<RouteGuardProps> = ({ moduleName, children }) => {
  const { hasPermission } = usePermissions();
  const isLoading = useAuthStore((state) => state.isLoading);
  const user = useAuthStore((state) => state.user);

  // Mientras se carga la sesión, mostrar spinner
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  // Si no hay usuario cargado todavía, permitir temporalmente
  // (el PrivateRoute ya validó autenticación y checkCurrentRouteAccess hará su trabajo)
  if (!user) {
    return <>{children}</>;
  }

  // Verificar permiso de lectura en el módulo
  const hasAccess = hasPermission(moduleName, 'ver');

  if (!hasAccess) {
    const fallbackRoute = user ? getFirstAccessibleRoute(user) : '/dashboard';
    return <Navigate to={fallbackRoute} replace />;
  }

  return <>{children}</>;
};
